import axios from '@/modules/login/service/axios-login';

const validar = (cnpj) => axios.get(`/open/companies/${cnpj}`);
const acesso = (cnpj) => axios.get(`/open/companies/${cnpj}/acesso`);
const validarChave = (chave) => axios.get(`/open/companies/${chave}/validar-chave`);
const solicitarUser = (id) => axios.put(`/open/companies/${id}/solicitar`);
const criar = (fornecedor) => axios.post('/open/companies/fornecedores', fornecedor);
const criarUser = (id, chave, data) => axios.put(`/open/companies/${id}/usuario/${chave}`, data);

export default {
  validar,
  acesso,
  validarChave,
  solicitarUser,
  criar,
  criarUser,
};
